export const no = {
  loading: 'Henter data',
};
